<template>
  <div class="add-product">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="appVersion.id ? $t('upgrade.editApk') : $t('upgrade.addApk')"
      :visible.sync="dialogApk"
      width="40%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form :label-position="labelPosition" :rules="rules" ref="appVersion" label-width="80px" :model="appVersion">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('addAppVersion.appImage')">
                <el-upload
                  class="upload-icon"
                  :action="iconUploadUrl"
                  :headers="headers"
                  :on-success="iconSuccess"
                  :before-upload="iconUpload"
                  :on-remove="iconRemove"
                  :on-error="iconError"
                  :file-list="iconFileList"
                  list-type="picture-card"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('upgrade.addApk')" prop="url">
                <el-upload
                  class="upload-demo"
                  :action="appUploadUrl"
                  :headers="headers"
                  :on-success="appSuccess"
                  :on-error="appError"
                  :on-remove="appRemove"
                  :limit="1"
                  :multiple="false"
                  :accept="'.apk'"
                  :before-upload="handleBefore"
                  :file-list="appFileList"
                >
                  <el-button slot="trigger" size="small" type="primary">{{ $t("addAppVersion.trigger") }}</el-button>
                  <div v-if="isFileUploading" slot="tip" class="el-upload__tip" style="color: #e6a23c">
                    {{ $t('upgrade.AddApk.639841-0') }}
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('addAppVersion.appVersionBefore')" prop="prefix">
                <el-input
                  v-model="appVersion.prefix"
                  :placeholder="$t('addAppVersion.pAppVersionBefore')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('upgrade.appVersion')" prop="version">
                <el-input
                  v-model="appVersion.version"
                  :placeholder="$t('upgrade.pAppVersion')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('upgrade.firmwareId')" prop="choosedVMC">
                <el-select
                  v-model="appVersion.choosedVMC"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  filterable
                  collapse-tags
                  multiple
                  :placeholder="$t('upgrade.pFirmwareId')"
                >
                  <el-option v-for="item in vmcList" :key="item.id" :label="item.version" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('upgrade.notes')">
                <el-input type="textarea" :rows="4" v-model="appVersion.notes"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm || isFileUploading" @click="submitForm('appVersion')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  export default {
    name: "AddApk",
    props: {
      appVersion: Object,
      dialogApk: Boolean
    },
    data() {
      return {
        labelPosition: "top",
        rules: {
          prefix: [
            {
              required: true,
              message: this.$t("addAppVersion.pAppVersionBefore"),
              trigger: "blur"
            }
          ],
          version: [
            {
              required: true,
              message: this.$t("addAppVersion.pAppVersion"),
              trigger: "blur"
            }
          ],
          choosedVMC: [
            {
              required: true,
              message: this.$t("upgrade.pFirmwareId"),
              trigger: "blur"
            }
          ],
          url: [
            {
              required: true,
              message: this.$t("addAppVersion.rDownUrl"),
              trigger: "blur"
            }
          ]
        },
        limit: 1,
        clear: false,
        loadingForm: false,
        headers: {
          token: this.$cookies.get("token")
        },
        iconUploadUrl: config.baseUrl + this.$url.Upload.appIcon,
        iconFileList: [],
        appUploadUrl: config.baseUrl + this.$url.Upload.app,
        appFileList: [],
        vmcList: [],
        isFileUploading: false
      };
    },
    methods: {
      handleBefore(file) {
        let name = file.name.replace(".apk", "");
        let fileName = file.name;
        this.appVersion.name = name;
        this.appVersion.fileName = fileName;
        this.isFileUploading = true;
        return true;
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        console.log(this.appVersion);

        if (this.isFileUploading) {
          this.$message.warning(this.$t('upgrade.AddApk.639841-1'));
          return;
        }

        if (!this.appVersion.url) {
          this.$message.warning(this.$t('upgrade.AddApk.639841-2'));
          return;
        }

        let wtype = localStorage.getItem("wType") || "";
        let tArr = this.appVersion.version;
        tArr = tArr.split("");
        tArr.forEach(item => {
          if (!(item === "." || (item < 10 && item >= 0))) {
            this.$message.warning(this.$t("upgrade.verError"));
            throw this.$t('upgrade.AddApk.639841-3');
          }
        });
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            let url = this.$url.Upgrade.appInsert;
            let method = this.$method.post;
            if (this.appVersion.id) {
              url = this.$url.Upgrade.appUpdate;
              method = this.$method.put;
            }
            this.appVersion.type = wtype;

            let rData = JSON.parse(JSON.stringify(this.appVersion));
            console.log(rData);
            rData.vmc = rData.choosedVMC.map(item => {
              return { id: item };
            });
            delete rData.choosedVMC;
            console.log(rData);

            this.$api
              .request(url, method, rData)
              .then(res => {
                this.loadingForm = false;
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.clear = true;
                  this.cancel(this.appVersion.id ? "update" : "save");
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "error"
                  });
                }
              })
              .catch(err => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: err.msg,
                  type: "error"
                });
                this.loadingForm = false;
              });
          }
        });
      },
      closeDialog() {
        this.clearValidate("appVersion");
        if (this.appVersion.id) {
          this.$toolUtil.clearForm(this.appVersion);
        } else {
          if (this.clear) {
            this.$toolUtil.clearForm(this.appVersion);
          }
        }
        this.cancel("");
        this.iconFileList = [];
        this.appFileList = [];
        this.isFileUploading = false;
      },
      openDialog() {
        this.$api
          .request(this.$url.Upgrade.listFirmware, this.$method.get, {})
          .then(res => {
            this.vmcList = res.data;
            if (this.appVersion.id) {
              if (this.iconFileList.length <= 0 && this.appVersion.img) {
                this.iconFileList.push({ url: this.appVersion.img });
                this.hideUpload();
              } else {
                this.showUpload();
              }

              if (this.appFileList.length <= 0 && this.appVersion.url) {
                this.appFileList.push({
                  name: this.appVersion.name,
                  url: this.appVersion.url
                });
              }
              this.appVersion.choosedVMC = this.appVersion.vmc.map(item => item.id);
              console.log(this.appVersion.choosedVMC, 1361983);
            } else {
              this.showUpload(true);
            }
          })
          .catch(() => {});
      },
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },
      hideUpload() {
        this.$nextTick(() => {
          let card = window.document.querySelector(".el-upload--picture-card");
          card.style.display = "none";
        });
      },
      showUpload(boo) {
        if (boo) {
          this.$nextTick(() => {
            let card = window.document.querySelector(".el-upload--picture-card");
            card.style.display = "block";
          });
        } else {
          setTimeout(() => {
            let card = window.document.querySelector(".el-upload--picture-card");
            card.style.display = "block";
          }, 1000);
        }
      },
      iconUpload() {
        this.hideUpload();
      },
      iconSuccess(res) {
        if (res.code === 0) {
          this.appVersion.img = res.data;
        } else {
          this.$message.warning(res.msg ? res.msg : this.$t("addAppVersion.error"));
          this.iconFileList = [];
          this.showUpload();
        }
      },
      iconError(err) {
        this.$message.error(err.msg ? err.msg : this.$t("addAppVersion.error"));
        this.showUpload();
      },
      iconRemove() {
        this.showUpload();
      },
      appSuccess(res) {
        this.isFileUploading = false;
        if (res.code === 0) {
          this.appVersion.url = res.data;
          this.$message.success(this.$t('upgrade.AddApk.639841-4'));
        } else {
          this.$message.error(res.msg || this.$t('upgrade.AddApk.639841-5'));
          this.appFileList = [];
          this.appVersion.url = "";
        }
      },
      appError(err) {
        this.isFileUploading = false;
        this.$message.error(err.msg ? err.msg : this.$t('upgrade.AddApk.639841-6'));
        this.appFileList = [];
        this.appVersion.url = "";
      },
      appRemove() {
        this.appVersion.url = "";
        this.isFileUploading = false;
        this.$message.warning(this.$t('upgrade.AddApk.639841-7'));
      }
    }
  };
</script>

<style lang="scss">
  .upload-icon {
    .el-upload--picture-card {
      width: 80px;
      height: 80px;
      line-height: 88px;
    }
    .el-upload-list__item {
      width: 80px !important;
      height: 80px !important;
      margin-bottom: 0 !important;
    }
    .el-form-item__content {
      line-height: 0;
    }
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .upload-app .el-upload__tip {
    line-height: 16px;
  }
</style>
